import React, { useEffect } from 'react';
import * as navigate from 'app/area/shared/navigation';
import { ButtonTertiary } from 'ui';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'app/types-store';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { actionCreators } from './actions';
import { getBreadcrumbs, getBreadcrumbsFromPath } from './get-breadcrumbs';
import { CodetableAccessState } from './types-store';

interface ExtraFooterButtonProps {
  codetableId: number;
  breadcrumbs: number[];
  categoryId: number;
  label: string;
  onClose: () => void;
}

const ExtraFooterButton = ({ codetableId, breadcrumbs, categoryId, label, onClose }: ExtraFooterButtonProps) => {

  const codetableAccessState = useSelector<ApplicationState, CodetableAccessState>(
    state => state.codetableAccess
  );

  const codetableAccess = codetableAccessState?.codetableAccess?.find(access => access.id === codetableId);
  const fetching = codetableAccessState?.fetching?.includes(codetableId) ?? false;
  const hierarchy = codetableAccessState?.hierarchy ?? [];
  const fetchingHierarchy = codetableAccessState?.fetchingHierarchy ?? false;
  const forbiddenAccess = codetableAccessState?.forbiddenAccess ?? false;

  const dispatch = useDispatch();

  useEffect(() => {
    if (!forbiddenAccess && isDefinedIncludingZero(codetableId) && !codetableAccess && !fetching) {
      dispatch(actionCreators.loadCodetableAccess(codetableId));
    }
  }, [codetableId]);

  useEffect(() => {
    if (!forbiddenAccess && !fetchingHierarchy && hierarchy.length === 0) {
      dispatch(actionCreators.loadHierarchy());
    }
  }, []);

  if (forbiddenAccess || fetchingHierarchy ||
    (!codetableAccess?.create && !codetableAccess?.administrationCentral)) {
    return null;
  }

  const handleClick = () => {
    onClose?.();

    const getBreadcrumbsFromPathResult = getBreadcrumbsFromPath(hierarchy, breadcrumbs, codetableId);
    const getBreadcrumbsResult = getBreadcrumbs(hierarchy, codetableId);
    const breadcrumbsResult = getBreadcrumbsFromPathResult.length > 0
      ? getBreadcrumbsFromPathResult
      : getBreadcrumbsResult.length > 0
        ? getBreadcrumbsResult : [codetableId];

    navigate.toCodeListWithBreadcrumbs(breadcrumbsResult, categoryId);
  };

  return <ButtonTertiary onClick={handleClick}>
    {label}
  </ButtonTertiary>;
};

export const manageOptionsButton = (label: string, codetableId: number, breadcrumbs: number[] = [], categoryId?: number) =>
  (onClose: () => void) =>
    <ExtraFooterButton
      codetableId={codetableId}
      breadcrumbs={breadcrumbs}
      categoryId={categoryId}
      label={label}
      onClose={onClose} />;
